import React, { useRef } from "react";
import { useContent } from "contexts/contentContext/contentContext.js";
import config from "config";

const useWaitForFilesModal = () => {
  const { getTextByKey } = useContent();

  const div = useRef(document.createElement("div"));

  const onStart = async () => {
    div.current.className = "uploader-wait-for-files";
    const image = document.createElement("img");
    image.src = `${config.api.resource}/assets/images/loader.gif`;
    image.className = "img-loader";
    div.current.appendChild(image);
    const text = document.createElement("div");
    text.innerText = getTextByKey("loading-files-text-uploader");
    div.current.appendChild(text);
    document.body.appendChild(div.current);
  };

  const onEnd = async () => {
    div.current.innerHTML = "";
    div.current.remove();
  };

  return { onStart, onEnd };
};
export default useWaitForFilesModal;
